import { useState } from 'react';
import './FeedbackWidget.css';

function FeedbackWidget() {
  const [feedbackGiven, setFeedbackGiven] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [followUpText, setFollowUpText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const sendToGA = (isHelpful, comment = null) => {
    // Send to Google Analytics 4
    if (window.gtag) {
      window.gtag('event', 'feedback_submitted', {
        event_category: 'engagement',
        event_label: isHelpful ? 'helpful' : 'not_helpful',
        value: isHelpful ? 1 : 0,
        feedback_helpful: isHelpful,
        feedback_comment: comment || undefined
      });
    }
  };

  const handleThumbsUp = () => {
    sendToGA(true);
    setFeedbackGiven(true);
    setSubmitted(true);
  };

  const handleThumbsDown = () => {
    sendToGA(false);
    setFeedbackGiven(true);
    setShowFollowUp(true);
  };

  const handleFollowUpSubmit = (e) => {
    e.preventDefault();
    if (followUpText.trim()) {
      // Send additional feedback to GA
      if (window.gtag) {
        window.gtag('event', 'feedback_comment', {
          event_category: 'engagement',
          event_label: 'improvement_suggestion',
          feedback_text: followUpText.trim()
        });
      }
    }
    setSubmitted(true);
    setShowFollowUp(false);
  };

  const handleSkip = () => {
    setSubmitted(true);
    setShowFollowUp(false);
  };

  if (submitted) {
    return (
      <div className="feedback-widget submitted">
        <span className="feedback-thanks">Thanks for your feedback!</span>
      </div>
    );
  }

  return (
    <div className="feedback-widget">
      {!feedbackGiven ? (
        <>
          <span className="feedback-question">Was this helpful?</span>
          <div className="feedback-buttons">
            <button
              type="button"
              className="feedback-btn thumbs-up"
              onClick={handleThumbsUp}
              aria-label="Yes, this was helpful"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
              </svg>
              <span>Yes</span>
            </button>
            <button
              type="button"
              className="feedback-btn thumbs-down"
              onClick={handleThumbsDown}
              aria-label="No, this was not helpful"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
              </svg>
              <span>No</span>
            </button>
          </div>
        </>
      ) : showFollowUp ? (
        <form className="feedback-followup" onSubmit={handleFollowUpSubmit}>
          <label htmlFor="feedback-text">How can we improve?</label>
          <textarea
            id="feedback-text"
            value={followUpText}
            onChange={(e) => setFollowUpText(e.target.value)}
            placeholder="What would make this more useful?"
            rows="3"
            maxLength="500"
          />
          <div className="followup-actions">
            <button type="submit" className="submit-btn">
              Submit
            </button>
            <button type="button" className="skip-btn" onClick={handleSkip}>
              Skip
            </button>
          </div>
        </form>
      ) : null}
    </div>
  );
}

export default FeedbackWidget;
